"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = KonvaTransformGroup;
var _react = _interopRequireWildcard(require("react"));
var _reactKonva = require("react-konva");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children", "id", "isSelected", "disabled", "visible", "onMouseDown", "onDragMove"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function findMarker() {
  var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var shapes = ["Rect", "Circle", "Ellipse", "Line"];
  return children.find(function (obj) {
    return shapes.includes(obj.className);
  });
}
function KonvaTransformGroup(_ref) {
  var children = _ref.children,
    id = _ref.id,
    _ref$isSelected = _ref.isSelected,
    isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$visible = _ref.visible,
    visible = _ref$visible === void 0 ? true : _ref$visible,
    _onMouseDown = _ref.onMouseDown,
    onDragMove = _ref.onDragMove,
    listeners = _objectWithoutProperties(_ref, _excluded);
  var transformRef = (0, _react.useRef)();
  var groupRef = (0, _react.useRef)();
  var isActive = (0, _react.useMemo)(function () {
    return isSelected && !disabled;
  }, [isSelected, disabled]);
  var handleOnDragMove = function handleOnDragMove(e) {
    onDragMove === null || onDragMove === void 0 ? void 0 : onDragMove({
      target: findMarker(e.target.getChildren())
    });
  };
  (0, _react.useEffect)(function () {
    if (isActive) {
      var group = groupRef.current;

      // find valid marker
      var marker = findMarker(group.getChildren());
      marker.strokeScaleEnabled(false);

      // attach Konva.Transformer manually
      if (marker.className !== "Circle") {
        transformRef.current.nodes([marker]);
        transformRef.current.moveToTop();
        transformRef.current.getLayer().batchDraw();
      }
    }
  }, [isActive]);
  (0, _react.useEffect)(function () {
    // force update: Konva.Transformer cannot track deep changes inside Konva.Group
    if (transformRef.current) {
      transformRef.current.forceUpdate();
    }
  }, [children]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.default.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactKonva.Group, _objectSpread(_objectSpread({
      ref: groupRef,
      name: id,
      onMouseDown: function onMouseDown(e) {
        return _onMouseDown === null || _onMouseDown === void 0 ? void 0 : _onMouseDown(e, id);
      },
      onDragMove: handleOnDragMove,
      visible: visible
    }, listeners), {}, {
      children: children
    })), isActive && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactKonva.Transformer, {
      ref: transformRef,
      ignoreStroke: true,
      rotateEnabled: false,
      enabledAnchors: ["top-left", "top-right", "bottom-left", "bottom-right"]
      // boundBoxFunc={(oldBox, newBox) => newBox}
      ,
      useSingleNodeRotation: false // http://disq.us/p/2obrqj3
      ,
      keepRatio: false // http://disq.us/p/2uu3bzt
    })]
  });
}